export const environment = {
  production: false,
  url: 'https://dev.terminologyhub.com',
  email: 'info@terminologyhub.com',
  ga_code: '',
  version: require('../../package.json').version,
};
